export class Allergen {
  id: number;
  allergenTypeId: number;
  allergenTypeDescription: string;
  code: string;
  description: string;
  dataSourceId: number;
  active: boolean;
  dateCreated: Date;
  createdBy: number;
  dateUpdated?: any;
  updatedBy?: any;
  deleted: boolean;
  dateDeleted?: any;
  deletedBy?: any;
}
export class AllergenData {
  id: number;
  userId: number;
  allergenId: number;
  allergenDescription: string;
  allergySeverityId: number;
  allergySeverityDescription: string;
  description?: any;
  reaction: string;
  identificationDate: Date;
  active: boolean;
  dateCreated: Date;
  createdBy: number;
  dateUpdated?: any;
  updatedBy?: any;
  deleted: boolean;
  dateDeleted?: any;
  deletedBy?: any;
}

export class PatientAllergen {
  allergenId: number;
  reaction: string;
  identificationDate: Date;
  description: string;
}